export enum LOGIN_TYPE_ENUM {
  INTERNAL = 'internal',
  CLIENT = ' client',
  GDC = 'gdc',
}
